import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateStep } from '../../../state';

interface StepDescriptionFieldProps {
  index: number;
}

export const StepDescriptionField: React.FC<StepDescriptionFieldProps> = ({ index }) => {
  const dispatch = useAppDispatch();
  const step = useAppSelector((state) => state.workflow.currentWorkflow?.steps[index]);

  if (!step) return null;

  return (
    <TextField
      size="small"
      label="Description"
      value={step.description}
      onChange={(e) => dispatch(updateStep({ index, updates: { description: e.target.value } }))}
      fullWidth
      placeholder="Describe what this step does..."
    />
  );
};

export default StepDescriptionField;
